import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { I18nService } from '@app/core';
import { UtilService } from './util.service';
import { CryptographyService } from '@app/cryptography.service';
import { environment } from '@env/environment';

@Injectable()
export class ApiService {
  private API_URL: any;
  private API_CUSTOM_URL: any;
  private ipClient: string;
  constructor(
    private http: Http,
    private route: Router,
    private i18nService: I18nService,
    private util: UtilService,
    private httpClient: HttpClient,
    private crypto: CryptographyService
  ) { }

  async get(system: string, action: string, queryParam?: string) {

    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)
    
    let routStr = ""
    if(queryParam == null || queryParam == ""){
      routStr = this.crypto.encrypt("/" + system + "/" + action, aesKey)
    }
    else{
      routStr = this.crypto.encrypt("/" + system + "/" + action +  "?" + queryParam, aesKey)
    }

    let reqObj = {
      m: this.crypto.encrypt("GET", aesKey),
      route: routStr,
      s: aesPublic
    }
    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/Core/PostApi"
    //url = "https://dpaapi.msccrm.com:443/customApi/api/Core/PostApi"

    return new Promise(resolve => {
      this.http.post(url, reqObj).toPromise().then(async (data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async getMasterAddress() {

    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/master/address"
    //url = "https://dpaapi.msccrm.com:443/customApi/api/master/address"

    return new Promise(resolve => {
      this.http.get(url).toPromise().then((data) => {
        let res = data.json();
        resolve(res);
      }).catch((err) => {
        this.util.ShowWaiting(false);
        console.error("get address failed.")
      });
    });
  }

  async getCustomAPI(system: string, action: string, queryParam?: string) {

    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let routStr = ""
    if(queryParam == null || queryParam == ""){
      routStr = this.crypto.encrypt("/api/" + system + "/" + action, aesKey)
    }
    else{
      routStr = this.crypto.encrypt("/api/" + system + "/" + action + "?" + queryParam, aesKey)
    }
    
    let reqObj = {
      route: routStr,
      s: aesPublic
    }

    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
    url += "/api/" + system + "/" + action //+ param
    //url = "https://dpaapi.msccrm.com:443/customApi/api/" + system + "/" + action

    return new Promise(resolve => {
      this.http.post(url, reqObj).toPromise().then(async (data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async post(system: string, action: string, dataObj: object, callByNull : boolean = false) {
    if(callByNull){
      dataObj["dpa_callby"] = ''
    }
    else{
      dataObj["dpa_callby"] = '1'
    }
    
    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)
    
    let reqObj2 = {
      m: this.crypto.encrypt("POST", aesKey),
      route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
      s: aesPublic,
      req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
    }

    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/Core/PostApi"
    //url = "https://dpaapi.msccrm.com:443/customApi/api/Core/PostApi"

    return new Promise(resolve => {
      this.http.post(url, reqObj2).toPromise().then((data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async postCustom(system: string, action: string, dataObj: object, mode?: string, branchID?: string) {
    
    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/" + system + "/" + action;
    //url = "https://dpaapi.msccrm.com:443/customApi/api/" + system + "/" + action

    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj: any = { ...dataObj }
    reqObj = this.crypto.encryptDictValue(reqObj)
    reqObj["s"] = aesPublic
    
    return new Promise(resolve => {
      this.http.post(url, reqObj).toPromise().then((data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async put(system: string, action: string, dataObj: object, mode?: string, branchID?: string) {
    dataObj["dpa_callby"] = '1'

    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj2 = {
      m: this.crypto.encrypt("PUT", aesKey),
      route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
      s: aesPublic,
      req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
    }

    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
    url += "/api/Core/PostApi"
    //url = "https://dpaapi.msccrm.com:443/customApi/api/Core/PostApi"

    return new Promise(resolve => {
      this.http.post(url, reqObj2).toPromise().then((data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async getConfig() {
    let configData = '';

    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(this.crypto.decrypt(res.apiUrl))
      }).catch((err) => {
        //this.util.ShowWaiting(false);
        // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
        // this.route.navigate(['/error']);
      });
    });
  }

  async getCustomAPIConfig() {
    let configData = '';

    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(this.crypto.decrypt(res.customApiUrl))
      }).catch((err) => {
        //this.util.ShowWaiting(false);
        // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
        // this.route.navigate(['/error']);
      });
    });
  }


  async getConfigByKey(key: string) {
    let configData = '';

    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(this.crypto.decrypt(res.customApiUrl))
      }).catch((err) => {
        //this.util.ShowWaiting(false);
        // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
        // this.route.navigate(['/error']);
      });
    });
  }

  async getNotiApiUrl() {
    let configData = '';

    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(res.notiApiUrl)
      }).catch((err) => {
        //this.util.ShowWaiting(false);
        // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
        // this.route.navigate(['/error']);
      });
    });
  }


  async upload(system: string, action: string, dataObj: object) {

    if (this.API_URL == undefined || this.API_URL == null) {
      this.API_URL = await this.getConfig();
    }


    if (this.ipClient == undefined || this.ipClient == null) {
      this.ipClient = localStorage.getItem("clientIP");
    }



    const url = 'http://localhost:53675/api/upload/UploadFile';

    return new Promise(resolve => {
      this.http.post(url, dataObj).toPromise().then((data) => {
        const res = data.json();
        resolve(res);
      }).catch((err) => {

      });
    });
  }


  async getIP() {

    if (this.API_URL == undefined || this.API_URL == null) {
      this.API_URL = await this.getConfig();
    }

    var url = this.API_URL + "/ip/GetIp";

    return new Promise(resolve => {
      this.http.get(url).toPromise().then((data) => {
        const res = data.json();
        resolve(res);


      }).catch((err) => {
        //this.util.ShowWaiting(false);
      });
    });
  }

  async CheckSession() {
    //console.log("CheckSession");
    var result = false;
    if (this.API_URL == undefined || this.API_URL == null) {
      this.API_URL = await this.getConfig();
    }

    var url = this.API_URL + "/account/GetUserSessionCurrent";

    const header = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: header });
    var dataObj = {};
    dataObj["ip_address"] = this.util.GetCurrIP();
    dataObj["member_no"] = this.util.GetUserID();

    var datapost = {};
    datapost["user"] = this.util.GetUserID();
    datapost["ip"] = this.util.GetClientIP();
    datapost["lang"] = this.i18nService.language;
    datapost["requestData"] = dataObj;

    //console.log(url);
    var datares: any = await new Promise(resolve => {
      this.http.post(url, datapost, options).toPromise().then((data) => {
        const res = data.json();
        resolve(res);
      }).catch((err) => {
        //this.util.ShowWaiting(false);
        throw err;
      });
    });


    if (datares != null) {

      if (datares.isSuccess) {
        if (datares.responseData) {
          if (datares.responseData.length > 0) {
            result = true;
          }
        }

      }
    }
    if (!result) {
      localStorage.setItem("clientIP", null);
      localStorage.setItem("clientUser", null);
      localStorage.setItem("member_obj", null);
      var url_login: any = await this.getConfigLogin();
      window.location.href = url_login;
    }
    return result;
  }

  async postnotauthen(system: string, action: string, dataObj: object, mode?: string, branchID?: string) {

    if (this.API_URL == undefined || this.API_URL == null) {
      this.API_URL = await this.getConfig();
    }


    if (this.ipClient == undefined || this.ipClient == null) {
      this.ipClient = localStorage.getItem("clientIP");
    }



    const url = this.API_URL + '/' + system + '/' + action;

    const header = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: header });

    // var datahead = {};
    // datahead["client_ip"] = this.ipClient;
    // datahead["lang"] = this.i18nService.language;

    var datapost = {};
    datapost["user"] = this.util.GetUserID();
    datapost["ip"] = this.util.GetClientIP();
    datapost["lang"] = this.i18nService.language;
    datapost["requestData"] = dataObj;
    datapost["mode"] = mode;
    datapost["branch_id"] = branchID;
    //  dataObj = Object.assign(datahead, dataObj);
    return new Promise(resolve => {
      this.http.post(url, datapost, options).toPromise().then((data) => {
        const res = data.json();
        resolve(res);
      }).catch((err) => {
        //this.util.ShowWaiting(false);
        resolve(null)
        //this.util.ErrorDialog('System Error : ' + err);
      });
    });
  }

  async getConfigLogin() {
    let configData = '';

    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(res.UrlLogin)
      }).catch((err) => {
        //this.util.ShowWaiting(false);
        // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
        // this.route.navigate(['/error']);
      });
    });
  }
  
  async postCustomApi(system: string, action: string, dataObj: object) {
    //var url = await this.getConfigByKey("customApiUrl") + "/" + system + "/" + action;
    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/" + system + "/" + action;
    //url = "https://dpaapi.msccrm.com:443/customApi/api/" + system + "/" + action

    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj: any = { ...dataObj }
    reqObj = this.crypto.encryptDictValue(reqObj, aesKey)
    reqObj["s"] = aesPublic

    return new Promise(resolve => {
      this.http.post(url, reqObj).toPromise().then((data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }
  async getTokenConfig() {
    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(res)
      }).catch((err) => {
        return null
      });
    });
  }

  async getToken() {
    let config: any = await this.getTokenConfig()
    const url = this.crypto.decrypt(config.getTokenUrl)
    let req: any = {
      "username": config.getTokenUser,
      "password": config.getTokenPassword
    }

    const header = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: header });

    return new Promise(resolve => {
      this.http.post(url, req, options).toPromise().then((data) => {
        const res = data.json();
        resolve(res.AccessToken);
      }).catch((err) => {
        if (err.statusText == 'OK') {
          resolve(err)
        }
        else {
          //this.util.ShowWaiting(false);
          resolve(null)
        //this.util.ErrorDialog('System Error : ' + err);
        }
      });
    });
  }

  async getTestToken() {
    let config: any = await this.getTokenConfig()
    const url = config.getTokenUrl
    let req: any = {
      "username": config.getTokenUser,
      "password": config.getTokenPassword
    }
    return new Promise(resolve => {
      this.httpClient.post<any>(url, req).toPromise().then((data) => {
        resolve(data.AccessToken);
      }).catch((err) => {
        if (err.statusText == 'OK') {
          resolve(err)
        }
        else {
          //this.util.ShowWaiting(false);
          resolve(null)
        //this.util.ErrorDialog('System Error : ' + err);
        }
      });
    });
  }

  // async GetMaxUploadFileSize() {
  //   var Config: any = {};
  //   var DefaultValue = 10;
  //   Config = await this.EnvConfig(); 
  //   if (Config == null)
  //     return DefaultValue;
  //   else
  //     return Config.MaxFileSize;
  // }

  // async GetAcceptUploadFileExtension() {
  //   var DefaultValue = ".jpg, .jpeg, .pdf, .doc, .docx";
  //   var Config: any = {}
  //   Config = await this.EnvConfig(); 
  //   if (Config == null)
  //     return DefaultValue;
  //   else
  //     return Config.AcceptUploadFileExtension;
  // }

  async EnvConfig() {
    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(res);
      }).catch((err) => {
        resolve(null);
      });
    });
  }

  async getKey() {
    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
    url += "/api/" + "Key" + "/" + "GetKey"
    //url =  "https://dpaapi.msccrm.com:443/customApi/api/" + "Key" + "/" + "GetKey"

    return new Promise(resolve => {
      this.http.get(url).toPromise().then(async (data) =>  {
        let res = data.json();
        resolve(res);
      }).catch((err) => {
        this.util.ShowWaiting(false);
      });
    });
  }

  async keyFromCk(){
    let ck: any = JSON.parse(localStorage.getItem("dpa_cc"))

    if (ck != null && ck.pbk != null && ck.pbk != ""){
        return ck.pbk
    }
    else {
      if(ck == null){
        ck = {}
      }
      let getKeyRes: any = await this.getKey()
      ck.pbk = getKeyRes
      localStorage.setItem("dpa_cc", JSON.stringify(ck))
      return getKeyRes;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utility/api.service.ts